export const CODE_VIEW_DESIGNER_LOCALE = {
    'zh-CHS': {
        codeViewDesigner: {
            save: '保存',
            formDesigner: '设计器',
            codeDesigner: '代码',
            saveCurrentTab: '保存当前标签页',
            saveCurrentTabTip: '无论是否有修改，都重新保存当前标签页',
            find: '查找',
            collpaseOrExpandNavPanel: '收起/展开导航面板',
            collpaseOrExpandNavPanelTip: '收起/展开左侧的导航面板',
            openCommandPanel: '编辑器命令面板',
            formatDocument: '格式化文档',
            formatDocumentTip: '格式化文档（需要焦点在代码编辑器时触发）',
            saveSuccess: '保存成功',
            saveFailed: '保存失败',
            saveSuccessAll: '全部保存成功',
            saveVailate: '是否要保存对{param}的更改？',
            unsave: '不保存',
            cancel: '取消',
            unsaveInfo: '如果不保存，你的更改将丢失。',
            errorInfo: '错误提示',
            unsaveInfo2: '存在尚未保存的文件，是否继续跳转？',
            saveAndJump: '保存并跳转',
            nosaveAndJump: '仅跳转',
            close: '关闭',
            closeOthers: '关闭其他',
            closeRight: '关闭右侧',
            closeSaved: '关闭已保存',
            closeAll: '全部关闭',
            expandAll: '全部展开',
            collapseAll: '全部收折',
            search: '搜索',
            searchEmpty: '搜索结果为空'

        }
    },
    "zh-CHT": {
        codeViewDesigner: {
            save: '保存',
            formDesigner: '設計器',
            codeDesigner: '代碼',
            saveCurrentTab: '保存當前標簽頁',
            saveCurrentTabTip: '無論是否有修改，都重新保存當前標簽頁',
            find: '查找',
            collpaseOrExpandNavPanel: '收起/展開導航面板',
            collpaseOrExpandNavPanelTip: '收起/展開左側的導航面板',
            openCommandPanel: '編輯器命令面板',
            formatDocument: '格式化文檔',
            formatDocumentTip: '格式化文檔（需要焦點在代碼編輯器時觸發）',
            saveSuccess: '保存成功',
            saveFailed: '保存失敗',
            saveSuccessAll: '全部保存成功',
            saveVailate: '是否要保存對{param}的更改？',
            unsave: '不保存',
            cancel: '取消',
            unsaveInfo: '如果不保存，妳的更改將丟失。',
            errorInfo: '錯誤提示',
            unsaveInfo2: '存在尚未保存的文件，是否繼續跳轉？',
            saveAndJump: '保存並跳轉',
            nosaveAndJump: '僅跳轉',
            close: '關閉',
            closeOthers: '關閉其他',
            closeRight: '關閉右側',
            closeSaved: '關閉已保存',
            closeAll: '全部關閉',
            expandAll: '全部展開',
            collapseAll: '全部收折',
            search: '搜索',
            searchEmpty: '搜索結果爲空'
        }
    },
    'en': {
        codeViewDesigner: {
            save: 'Save',
            formDesigner: 'Designer',
            codeDesigner: 'Code',
            saveCurrentTab: 'Save the current TAB',
            saveCurrentTabTip: 'Save the current TAB again regardless of whether it has been modified',
            find: 'Find',
            collpaseOrExpandNavPanel: 'Collapse/expand the navigation panel',
            collpaseOrExpandNavPanelTip: 'Collapse/expand the left navigation panel',
            openCommandPanel: 'Open the command panel',
            openCommandPanelTip: 'Open the command panel of the code editor (requires focus to trigger while the code editor is in place)',
            formatDocument: 'Format the document',
            formatDocumentTip: 'Format the document (requires focus to trigger in the code editor)',
            saveSuccess: 'Successfully saved',
            saveFailed: 'Save failed',
            saveSuccessAll: 'All saved successfully ',
            saveVailate: 'Do you want to save the changes to {param}?',
            unsave: "Don't Save",
            cancel: 'Cancel',
            unsaveInfo: 'If not saved, your changes will be lost.',
            errorInfo: 'Error',
            unsaveInfo2: 'There are files that have not been saved yet. Do you want to continue redirecting?',
            saveAndJump: 'Save and Jump',
            nosaveAndJump: 'Only Jump',
            close: 'Close',
            closeOthers: 'Close Other',
            closeRight: 'Close Right Side',
            closeSaved: 'Close Saved',
            closeAll: 'Close All',
            expandAll: 'Expand All',
            collapseAll: 'Collapse All',
            search: 'Search',
            searchEmpty: 'Search result is empty'

        }
    }
};
export class DesignElementLocaleHandler {
    static getValue(key: string) {

        let languageCode = 'zh-CHS';
        if (window && window.top && window.top.localStorage && window.top.localStorage.languageCode) {
            languageCode = window.top.localStorage.languageCode;
        }

        return CODE_VIEW_DESIGNER_LOCALE[languageCode][key] || '';
    }
}